if (null !== document.querySelector('[data-toggle="collapse"]')) require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/modal');
